'use client';

import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export const fashionItems = [
    // 1. Shopping Bag
    <svg 
      key="bag"
      viewBox="0 0 120 140" 
      fill="none" 
      className="w-full h-auto drop-shadow-md"
    >
      <path d="M 60 40 C 60 15 90 15 90 35" stroke="#e5e7eb" strokeWidth="2" strokeLinecap="round" fill="none"/>
      <path d="M 85 40 L 100 30 L 100 85 L 85 95 Z" fill="#f3f4f6" stroke="#1f2937" strokeWidth="2" strokeLinejoin="round"/>
      <path d="M 25 40 L 40 30 L 100 30 L 85 40 Z" fill="#f9fafb" stroke="#1f2937" strokeWidth="1.5"/>
      <path d="M 35 40 L 42 25 L 50 35 L 58 22 L 65 40" fill="currentColor" strokeWidth="1" className="text-ruby-600 opacity-90"/>
      <path d="M 25 40 L 85 40 L 85 95 L 25 95 Z" fill="white" stroke="#1f2937" strokeWidth="2" strokeLinejoin="round"/>
      <path d="M 40 45 C 40 15 70 15 70 45" stroke="#1f2937" strokeWidth="2" strokeLinecap="round" fill="none"/>
      <circle cx="40" cy="45" r="1.5" fill="#1f2937"/>
      <circle cx="70" cy="45" r="1.5" fill="#1f2937"/>
      <circle cx="55" cy="75" r="3" fill="currentColor" className="text-ruby-600 opacity-80"/>
    </svg>,

    // 2. Luxury Dress
    <svg 
      key="dress"
      viewBox="0 0 120 160" 
      fill="none" 
      className="w-full h-auto drop-shadow-md"
    >
      <path d="M 60 2 L 60 10 M 35 15 C 35 5 85 5 85 15" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M 38 15 L 40 35 C 35 45 42 60 45 65 C 35 90 25 120 20 150 C 40 155 80 155 100 150 C 95 120 85 90 75 65 C 78 60 85 45 82 35 L 84 15" stroke="#1f2937" strokeWidth="2" fill="white" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M 38 15 Q 60 45 84 15" stroke="#1f2937" strokeWidth="2" fill="none"/>
      <path d="M 45 65 Q 60 70 75 65 L 75 72 Q 60 77 45 72 Z" fill="currentColor" className="text-ruby-600" strokeWidth="1"/>
      <path d="M 70 72 Q 65 100 85 150" stroke="#1f2937" strokeWidth="1.5" fill="none"/>
      <path d="M 50 72 Q 45 110 40 150" stroke="#e5e7eb" strokeWidth="1.5" fill="none"/>
      <path d="M 60 72 Q 60 110 65 150" stroke="#e5e7eb" strokeWidth="1.5" fill="none"/>
    </svg>,

    // 3. Handbag Center
    <svg key="handbag-center" viewBox="0 0 140 140" fill="none" className="w-full h-auto drop-shadow-lg">
      <rect x="32" y="52" width="76" height="65" stroke="#1f2937" strokeWidth="2.5" fill="white" rx="4"/>
      <path d="M 37 52 L 42 117 L 98 117 L 103 52" stroke="#1f2937" strokeWidth="2.5" fill="none"/>
      <path d="M 47 52 Q 47 28 70 28 Q 93 28 93 52" stroke="#1f2937" strokeWidth="2.5" fill="none"/>
      <circle cx="70" cy="85" r="3" fill="currentColor" className="text-ruby-600"/>
      <line x1="50" y1="75" x2="90" y2="75" stroke="#e5e7eb" strokeWidth="1.5"/>
    </svg>,

    // 4. Handbag Right
    <svg key="handbag-right" viewBox="0 0 140 140" fill="none" className="w-full h-auto drop-shadow-lg">
      <rect x="32" y="52" width="76" height="65" stroke="#1f2937" strokeWidth="2.5" fill="white" rx="4"/>
      <path d="M 37 52 L 42 117 L 98 117 L 103 52" stroke="#1f2937" strokeWidth="2.5" fill="none"/>
      <path d="M 47 52 Q 47 28 70 28 Q 93 28 93 52" stroke="#1f2937" strokeWidth="2.5" fill="none"/>
      <circle cx="70" cy="85" r="3" fill="currentColor" className="text-ruby-600"/>
      <line x1="50" y1="75" x2="90" y2="75" stroke="#e5e7eb" strokeWidth="1.5"/>
    </svg>,

    // 5. Handbag Left
    <svg key="handbag-left" viewBox="0 0 140 140" fill="none" className="w-full h-auto drop-shadow-lg">
      <rect x="32" y="52" width="76" height="65" stroke="#1f2937" strokeWidth="2.5" fill="white" rx="4"/>
      <path d="M 37 52 L 42 117 L 98 117 L 103 52" stroke="#1f2937" strokeWidth="2.5" fill="none"/>
      <path d="M 47 52 Q 47 28 70 28 Q 93 28 93 52" stroke="#1f2937" strokeWidth="2.5" fill="none"/>
      <circle cx="70" cy="85" r="3" fill="currentColor" className="text-ruby-600"/>
      <line x1="50" y1="75" x2="90" y2="75" stroke="#e5e7eb" strokeWidth="1.5"/>
    </svg>,

    // 6. Sunglasses
    <svg key="sunglasses" viewBox="0 0 100 60" fill="none" className="w-full h-auto drop-shadow-md">
      <rect x="8" y="20" width="32" height="22" rx="11" stroke="#1f2937" strokeWidth="2.5" fill="white"/>
      <rect x="60" y="20" width="32" height="22" rx="11" stroke="#1f2937" strokeWidth="2.5" fill="white"/>
      <path d="M 40 30 L 60 30" stroke="#1f2937" strokeWidth="2.5"/>
      <path d="M 8 26 L 2 20" stroke="#1f2937" strokeWidth="2.5" strokeLinecap="round"/>
      <path d="M 92 26 L 98 20" stroke="#1f2937" strokeWidth="2.5" strokeLinecap="round"/>
      <path d="M 18 30 L 28 25" stroke="#e5e7eb" strokeWidth="1.5" opacity="0.6"/>
      <path d="M 70 30 L 80 25" stroke="#e5e7eb" strokeWidth="1.5" opacity="0.6"/>
    </svg>,

    // 7. Watch
    <svg key="watch" viewBox="0 0 80 100" fill="none" className="w-full h-auto drop-shadow-md">
      <circle cx="40" cy="50" r="22" stroke="#1f2937" strokeWidth="2.5" fill="white"/>
      <line x1="40" y1="50" x2="40" y2="38" stroke="#1f2937" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="40" y1="50" x2="48" y2="50" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" className="text-ruby-600"/>
      <rect x="32" y="15" width="16" height="13" stroke="#1f2937" strokeWidth="2" fill="white" rx="2"/>
      <rect x="32" y="72" width="16" height="13" stroke="#1f2937" strokeWidth="2" fill="white" rx="2"/>
      <circle cx="40" cy="50" r="2" fill="#1f2937"/>
      <path d="M 48 38 L 50 36" stroke="#e5e7eb" strokeWidth="1.5"/>
      <path d="M 48 62 L 50 64" stroke="#e5e7eb" strokeWidth="1.5"/>
    </svg>,

    // 8. Perfume
    <svg key="perfume" viewBox="0 0 90 130" fill="none" className="w-full h-auto drop-shadow-md">
      <rect x="32" y="12" width="26" height="14" stroke="#1f2937" strokeWidth="2.5" fill="white" rx="2"/>
      <rect x="36" y="26" width="18" height="9" stroke="#1f2937" strokeWidth="2.5" fill="white"/>
      <rect x="27" y="35" width="36" height="68" stroke="#1f2937" strokeWidth="2.5" fill="white" rx="4"/>
      <line x1="32" y1="58" x2="58" y2="58" stroke="#e5e7eb" strokeWidth="1.5"/>
      <rect x="40" y="68" width="10" height="18" stroke="#1f2937" strokeWidth="2" fill="none" rx="1"/>
      <path d="M 45 75 L 45 82" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="text-ruby-600"/>
    </svg>,

    // 9. Men's Suit
    <svg 
      key="suit"
      viewBox="0 0 100 120" 
      fill="none" 
      className="w-full h-auto drop-shadow-md"
    >
      <path d="M 50 5 C 50 0 58 0 58 5 L 58 10" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round"/>
      <path d="M 20 25 L 50 15 L 80 25 L 80 50 L 75 105 L 25 105 L 20 50 L 20 25 Z" fill="white" stroke="#1f2937" strokeWidth="2" strokeLinejoin="round"/>
      <path d="M 50 65 L 35 25 L 50 15 L 65 25 L 50 65" fill="white" stroke="#1f2937" strokeWidth="1.5" strokeLinejoin="round"/>
      <path d="M 42 18 L 50 25 L 58 18" stroke="#1f2937" strokeWidth="1"/>
      <path d="M 50 25 L 46 30 L 50 75 L 54 30 Z" fill="currentColor" className="text-ruby-600" strokeWidth="0.5"/>
      <path d="M 62 40 L 72 40 L 72 38" stroke="#1f2937" strokeWidth="1"/>
      <path d="M 64 38 L 68 34 L 70 38" fill="currentColor" className="text-ruby-600" opacity="0.8"/>
      <circle cx="50" cy="70" r="1.5" fill="#1f2937"/>
      <path d="M 20 50 L 25 105" stroke="#1f2937" strokeWidth="1" strokeOpacity="0.1"/>
      <path d="M 80 50 L 75 105" stroke="#1f2937" strokeWidth="1" strokeOpacity="0.1"/>
    </svg>
  ];

export default function KennyDBFashionHero() {
  const [isOrdered, setIsOrdered] = useState(false);

  // Define specific chaotic rotations for each item to ensure consistency
  const chaoticRotations = [-15, 20, -8, 12, -20, 35, -12, 18, -5];


  return (
    <div className="relative w-full min-h-[90vh] md:min-h-screen bg-gradient-to-br from-honey-50 via-white to-ruby-50/30 flex flex-col md:flex-row items-center justify-center overflow-hidden px-4 md:px-12 lg:px-24 py-12">
      
      {/* Subtle background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
        <motion.div 
          animate={{
            opacity: isOrdered ? 0.3 : 0.2,
            scale: isOrdered ? 1 : [1, 1.1, 1]
          }}
          transition={{ duration: 2, repeat: Infinity }}
          className="absolute top-20 left-10 w-72 h-72 bg-ruby-100/20 rounded-full blur-3xl"
        />
        <motion.div 
          animate={{
            opacity: isOrdered ? 0.2 : 0.1,
            scale: isOrdered ? 1 : [1, 1.15, 1]
          }}
          transition={{ duration: 2.5, repeat: Infinity }}
          className="absolute bottom-20 right-10 w-96 h-96 bg-ruby-200/10 rounded-full blur-3xl"
        />
      </div>

      {/* LEFT SIDE: The Rectangle (Grid of Items) */}
      {/* Order: 2 on mobile (below text), 1 on desktop (left side) */}
      <div className="relative z-10 w-full md:w-1/3 lg:w-1/4 flex flex-col items-center justify-center order-2 md:order-1 mt-8 md:mt-0">
        <div className="grid grid-cols-3 md:grid-cols-3 gap-3 md:gap-4 w-full max-w-[300px] md:max-w-none">
          {fashionItems.map((item, i) => (
            <motion.div
              key={i}
              // Chaos: Random rotation, lower opacity. Order: Aligned, full opacity
              animate={{
                rotate: isOrdered ? 0 : chaoticRotations[i],
                scale: isOrdered ? 1 : 0.85,
                opacity: isOrdered ? 1 : 0.7,
              }}
              transition={{
                duration: 0.6,
                delay: i * 0.05,
                type: "spring",
                stiffness: 200
              }}
              className="aspect-square bg-white/50 md:bg-white/80 backdrop-blur-sm rounded-xl md:rounded-2xl shadow-sm md:shadow-md flex items-center justify-center border border-white/60 p-2 hover:bg-white transition-colors cursor-pointer"
            >
              <div className="w-full h-full">
                {item}
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* RIGHT SIDE: The Phrase (Branding & Controls) */}
      {/* Order: 1 on mobile (top text), 2 on desktop (right side) */}
      <div className="relative z-20 w-full md:w-2/3 lg:w-3/4 flex flex-col items-center md:items-end md:justify-center text-center md:text-right order-1 md:order-2">
        
        {/* Logo Container - Using spans instead of h1 to maintain single h1 per page for LLM/SEO */}
        <div className="relative flex items-baseline leading-none tracking-tight mb-2" role="banner" aria-label="KennyDB Fashion">
          <motion.span
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="text-5xl sm:text-6xl md:text-7xl lg:text-9xl font-black text-ruby-600 tracking-tighter font-serif"
          >
            Kenny
          </motion.span>

          <motion.span
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="text-5xl sm:text-6xl md:text-7xl lg:text-9xl font-black text-mocha-950 tracking-tighter font-serif"
          >
            DB
          </motion.span>

          {/* FASHION label */}
          <motion.span 
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.9 }}
            className="absolute -bottom-1 right-0 text-[10px] sm:text-xs md:text-sm lg:text-base font-bold text-ruby-600 tracking-[0.2em] uppercase font-sans"
          >
            FASHION
          </motion.span>
        </div>

        {/* Tagline */}
        <motion.p 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 1.1 }}
          className="mt-4 sm:mt-6 text-lg sm:text-xl md:text-2xl lg:text-3xl text-mocha-600 font-light tracking-wide italic px-4 md:px-0 md:pr-4 font-sans"
        >
          The best tool for your agency
        </motion.p>

        {/* Decorative underline */}
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: isOrdered ? "80%" : "60%" }}
          transition={{ duration: 0.8, delay: 1.3, ease: "easeOut" }}
          className="mt-4 h-[1px] bg-gradient-to-r from-transparent via-ruby-300 to-transparent"
        />

        {/* Toggle Switch & Status */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.5 }}
          className="mt-8 md:mt-12 flex flex-col md:items-end items-center gap-4 md:gap-2"
        >
          <div className="flex items-center gap-3 md:gap-4">
            <motion.span 
              animate={{ 
                opacity: isOrdered ? 0.5 : 1,
                scale: isOrdered ? 0.95 : 1
              }}
              className="text-xs sm:text-sm md:text-base font-medium text-mocha-700 font-sans"
            >
              Senza KennyDB
            </motion.span>
            
            <button
              onClick={() => setIsOrdered(!isOrdered)}
              className={`relative w-14 h-7 sm:w-16 sm:h-8 rounded-full transition-colors duration-300 ${
                isOrdered ? 'bg-ruby-600' : 'bg-mocha-300'
              }`}
              aria-label="Toggle order"
            >
              <motion.div
                animate={{
                  x: isOrdered ? 28 : 0
                }}
                className="absolute top-1 left-1 w-5 h-5 sm:w-6 sm:h-6 bg-white rounded-full shadow-md"
                transition={{
                  type: "spring",
                  stiffness: 500,
                  damping: 30
                }}
              />
            </button>
            
            <motion.span 
              animate={{ 
                opacity: isOrdered ? 1 : 0.5,
                scale: isOrdered ? 1 : 0.95
              }}
              className="text-xs sm:text-sm md:text-base font-bold text-ruby-600 font-sans"
            >
              Con KennyDB
            </motion.span>
          </div>

          {/* Status Message */}
          <AnimatePresence mode="wait">
            <motion.p
              key={isOrdered ? 'ordered' : 'chaos'}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.5 }}
              className="text-xs sm:text-sm md:text-base text-mocha-500 italic px-4 md:px-0 font-sans"
            >
              {isOrdered 
                ? "✨ Tutto organizzato e sotto controllo" 
                : "😵 Caos e disorganizzazione"}
            </motion.p>
          </AnimatePresence>
        </motion.div>

      </div>
    </div>
  );
}